export class ChapterWiseDataModel {
    id: number;
    chapter: number;
    noOfQns: number;
    sectionWiseModel: number;
    constructor(chapter: number, noOfQns: number, sectionWiseModel: number) {
        this.chapter = chapter;
        this.noOfQns = noOfQns;
        this.sectionWiseModel = sectionWiseModel;
    }
}
